<template>
  <div id="app">
    <component :is="layout" v-if="this.languagesLoaded && $auth.ready()">
      <router-view :key="routeKey" />
    </component>

    <div v-else>
      Loading...
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import PublicLayout from '@/layouts/Public'
import PrivateLayout from '@/layouts/Private'
import { LAYOUT_CLEAR_ERRORS } from './store/modules/layout'
import { VUE_APP_BASE_API_URL } from './constants/fileConstants'
import { UI_LANGUAGES_SET_CURRENT_LANGUAGE } from './store/modules/uiLanguages'

export default {
  name: 'App',
  components: {
    PublicLayout,
    PrivateLayout
  },
  created() {
    this.onUserActivity()
    document.addEventListener('mousedown', this.onUserActivity)
    document.addEventListener('keypress', this.onUserActivity)

    this.prepareLanguages()
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.onUserActivity)
    document.removeEventListener('keypress', this.onUserActivity)
  },
  mounted() {
    if (localStorage.ui_language && localStorage.ui_language !== 'undefined') { // [todo]: Fix...
      this.$language.current = localStorage.ui_language
    }
  },
  data() {
    return {
      logoutTimeout: 3600 * 1000,
      logoutTimeoutId: null,
      languagesLoaded: false
    }
  },
  computed: {
    layout() {
      return this.$auth.check() ? 'private-layout' : 'public-layout'
    },
    routeKey() {
      return (this.$route || {}).path
    }
  },
  methods: {
    prepareLanguages() {
      const languageApiUrl = VUE_APP_BASE_API_URL + 'ui-languages/'

      axios.get(languageApiUrl).then((res) => {
        const currentLanguage = (this.$store.state.uiLanguages.currentLanguage || this.$language.current) || 'ces'

        this.$store.commit({
          type: UI_LANGUAGES_SET_CURRENT_LANGUAGE,
          value: currentLanguage,
          ids: JSON.stringify(res.data.data)
        })

        this.languagesLoaded = true
      })
    },
    onUserActivity() {
      clearTimeout(this.logoutTimeoutId)
      this.logoutTimeoutId = setTimeout(this.logout, this.logoutTimeout)
    },
    logout() {
      this.$auth.logout({
        redirect: '/'
      })
    }
  },
  watch: {
    '$route'(to, from) {
      this.$store.commit(LAYOUT_CLEAR_ERRORS)
    }
  }
}
</script>
